import { motion, useReducedMotion } from "framer-motion";
import { cn } from "@/lib/utils";

/**
 * Editorial section: numbered sticky label column (left) + content (right). Sections are separated by a hairline,
 * not boxed in cards.
 */
export const SectionShell = ({ id, no, title, lede, aside, children, className, testId }) => {
  const reduce = useReducedMotion();
  return (
    <motion.section
      id={id}
      className={cn("proposal-section border-t border-border/70", className)}
      aria-labelledby={`${id}-title`}
      initial={reduce ? false : { opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px 0px" }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      data-testid={testId || `proposal-section-${id}`}
    >
      <div className="mx-auto grid max-w-[1180px] gap-8 px-5 py-16 sm:px-8 lg:grid-cols-12 lg:gap-12 lg:py-24">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-24">
            <div className="font-mono text-[12.5px] tabular text-primary">{no}</div>
            <h2 id={`${id}-title`} className="proposal-display mt-2 text-[30px] font-semibold leading-tight sm:text-[36px]">{title}</h2>
            {lede && <p className="mt-3 max-w-[320px] text-[14.5px] leading-6 text-muted-foreground">{lede}</p>}
            {aside && <div className="mt-6">{aside}</div>}
          </div>
        </div>
        <div className="min-w-0 lg:col-span-8">{children}</div>
      </div>
    </motion.section>
  );
};
